/**
 * A dónde volver después de conectar una plataforma: Conexiones, con el acceso que quedó para
 * desplegarlo con sus cuentas a la vista (en una reconexión, el que ya existía). El backend lo
 * devuelve como `connection_id` (TikTok desde cc#205, Meta desde cc#209); sin él, la URL de siempre.
 */
export function connectedDestinationFor(channel, data) {
    const connectionId = data && data.data && data.data.connection_id;
    const base = '/agency/conections?just_connected=' + channel;
    return connectionId ? `${base}&credential=${encodeURIComponent(connectionId)}` : base;
}
